<template>
  <div class="register-two-step-page">
    <div class="register-form">
      <div class="title">快速注册</div>
      <div class="send-code-tip">短信验证码发送至 <span style="color: #1d8ae7">{{phone}}</span></div>
      <div class="input-group register-input-phone">
        <div class="input-label"><img class="icon-img" src="../../assets/icon-login-phone.png"></div>
        <input class="mint-field-core form-input" v-model="code" type="number" placeholder="请输入验证码">
        <div class="phone-code" :class="{'wait-send': waitSend}" @click="sendCode()">{{sendButtonText}}</div>
      </div>
      <div class="input-group">
        <div class="input-label">
          <img class="icon-lock" src="../../assets/icon-code.png">
        </div>
        <input class="mint-field-core form-input" type="password" v-model="password" placeholder="设置密码 6-20位的数字和字母组合">
      </div>
      <div v-if="regBtnActived" class="form-btn" @click="register" >提交</div>
      <div v-if="!regBtnActived" class="form-btn-unactived" @click="register" >提交</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import codeService from '../../service/phoneCode/CodeService'
  import customerUserService from '../../service/customer/UserService'

  export default {
    name: 'RegisterStepTwo',
    data () {
      return {
        phone: '',
        code:'',
        password:'',
        sendStatus: false,
        sendTime: 60,
        sendButtonText: '获取验证码',
        waitSend:false,
        regBtnActived:false
      }
    },
    created(){
      this.phone = this.$route.query.phone;
      document.title = this.$route.meta.title;
    },
    watch: {
      password(){
        if(this.code){
          this.regBtnActived = true;
        }
        if(!this.password){
          this.regBtnActived = false;
        }
      },
      code(){
        if(this.password){
          this.regBtnActived = true;
        }
        if(!this.code){
          this.regBtnActived = false;
        }
      }
    },
    beforeMount () {

    },
    methods: {
      async sendCode(){//发送验证码
        let phone = this.phone;
        this.sendStatus = true;
        let result = await codeService.sendPhoneCode(phone,1);
        if(result.code == '0'){
          Toast('验证码已发送至您的手机,请注意查收！');
          this.sendTime = 60;
          this.computeSendTime();
        }else {
          Toast('获取验证码失败');
        }
      },
      computeSendTime () {
        if (this.sendStatus) {
          if (this.sendTime == 0) {
            this.waitSend = false;
            this.sendStatus = false;
            this.sendButtonText = '重新获取'
          } else {
            this.waitSend = true;
            this.sendTime = this.sendTime - 1;
            this.sendButtonText = this.sendTime + '秒';
            setTimeout(() => {
              this.computeSendTime()
            }, 1000)
          }
        }
      },
      async register(){
        let password = this.password;
        if (password.length == 0) {
          Toast('请输入密码！');
          return false;
        }

        if(!/^([a-zA-Z0-9]|\w|[_!@#$&~|,，/.。?/？]){6,20}$/.test(password)){
          Toast('请正确填写密码');
          return;
        }
        if (this.code == null || this.code == '') {
          Toast('请填写验证码！');
        } else {
          let result = await codeService.checkPhoneCode(this.code, '1',this.phone);
          if (result.code == '0') {
            let res = await customerUserService.register(this.phone, password);
            if (res.code == '0') {
              Toast('注册成功!');
              this.$router.replace('/login');
            }else {
              Toast('注册失败，请稍后重试!');
            }
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .register-two-step-page{
    width: 7.5rem;
    height: 11.8rem;
    font-size: 0.36rem;
    color: #878e99;
    margin-top: -1rem;
    display: flex;
    background: white url("../../assets/icon-login-bg.png") no-repeat;
    background-position: center;
    background-size: cover;
    .register-form{
      width: 6.9rem;
      height: 7.1rem;
      margin: 2.1rem auto 0 auto;
      background-color: white;
      border-radius: 0.1rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
      .title{
        height: 1.2rem;
        line-height: 1.2rem;
        margin-left: 0.3rem;
        color: #191818;
        font-weight: bold;
      }
      .send-code-tip{
        height: 0.96rem;
        line-height: 0.96rem;
        font-size: 0.24rem;
        text-align: left;
        padding-left: 0.54rem
      }
    }
    .input-group{
      height: 0.9rem;
      width: 6.54rem;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      font-size: .26rem;
      color: #cbcbcb;
      margin: 0rem auto;
    }
    .input-group .input-label{
      width: 0.28rem;
      height: 0.42rem;
      padding-left:0.34rem;
      padding-right:.15rem;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .input-label .icon-lock{
      width: 0.36rem;
    }
    .input-label .icon-img{
      width: 100%;
      height: 100%;
    }
    .input-group .form-input{
      border: none;
      width: 4.5rem;
      padding-left: .2rem;
      flex-grow: 1;
      outline: none;
      height: 0.78rem;
      font-size: .26rem;
      line-height: 0.78rem;
      border-bottom: solid 1px #e0dedc;
    }
    .register-input-phone{
      margin-bottom: 0.28rem;
    }
    .phone-code {
      width: 2.2rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.06rem;
      color: #feac00;
    }
    .form-btn{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0rem auto;
      color: white;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background: #feac00;
    }
    .form-btn-unactived{
      width: 2.8rem;
      height: 0.9rem;
      margin: 0.94rem auto 0rem auto;
      color: white;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 0.45rem;
      background-color: #e0dedc;;
    }

    *::-webkit-input-placeholder { /* WebKit browsers*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *:-moz-placeholder {  /* Mozilla Firefox 4 to 18*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *::-moz-placeholder {  /* Mozilla Firefox 19+*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    *:-ms-input-placeholder { /* Internet Explorer 10+*/
      color:#cecbca!important;
      font-size:.32rem!important;
      padding-top:0.02rem;
    }
    .wait-send {
      pointer-events: none;
    }
  }

</style>
